export function fmtPrice(p: number | null | undefined): string {
  if (p == null || !Number.isFinite(p)) return '—';
  return p.toFixed(3);
}

export function fmtSize(s: number | null | undefined): string {
  if (s == null || !Number.isFinite(s)) return '—';
  if (s >= 10_000) return `${(s / 1_000).toFixed(1)}k`;
  return s.toFixed(0);
}

export function fmtMs(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '—';
  if (ms < 10) return ms.toFixed(1);
  return Math.round(ms).toString();
}
